module.exports = __webpack_public_path__ + "static/media/homeBgv2.a6c87299.png";